import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {Breadcrumb} from 'semantic-ui-react';

import CustomDivider from '../../components/extras/CustomDivider';
import SectionData from "../../data/SectionData";
import SectionDialog from "../../components/my_bisttro/SectionDialog";
import CheckPermission from "../../components/extras/CheckPermission";
import DynamicTable from "../../components/extras/DynamicTable";
import {dynamicTableAddOrUpdate, dynamicTableDelete} from "../../actions/DynamicTableDataAction";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import QuestionDialog from "../../components/extras/QuestionDialog";
import {sectionDialog} from "../../actions/SectionDialogAction";

class Sections extends Component {

    constructor() {
        super();
        this.state = {
            table: {
                headers: ['Sucursal', 'Sección', 'Acciones'],
                name: 'Sección',
                title: 'Secciones',
                has_actions: true,
                edit: true,
                can_add: true,
                pagination: true,
                delete: true,
                url: 'sections',
                values: ['id', 'name', 'branch_office', 'active'],
                boolean_fields: ['active'],
                child_fields: [{branch_office:'name'}],
                id: 'table_sections'
            },
        };
        this.delete = this.delete.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.section_select && nextProps.section_select.hasOwnProperty('id')){
            this.props.dynamicTableAddOrUpdate(nextProps.section_select);
        }
    }

    async delete(id) {
        SectionData.delete(id, (res) => {
            if (res.delete) {
                this.props.dynamicTableDelete(id);
                this.props.showToast({message: 'Sección Borrada!', type: 'success'});
            } else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'success'});
            }
        });
    };

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.props.sectionDialog({open:true, section:{id:null, name:'', branch_office:{id:null}}});
        }else if(response.event === 'edit'){
            this.props.sectionDialog({open:true, section:response.data});
        }else if(response.event === 'delete'){
            this.refs.deleteDialog.open('', response.data.id);
        }
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Secciones | Configuraciones - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/settings'>Configuraciones</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Secciones</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                <SectionDialog/>
                <QuestionDialog ref="deleteDialog" message="Borrar esta sección" callbackConfirm={this.delete}/>
                <CheckPermission access='settings__sections'/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        section_select: state.get('section_select'),
    };
}

function mapDispatchToProps(dispatch){
    return {
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
        dynamicTableDelete(data){
            dispatch(dynamicTableDelete(data))
        },
        showToast(data){
            dispatch(showToast(data))
        },
        sectionDialog(data){
            dispatch(sectionDialog(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Sections)


// WEBPACK FOOTER //
// ./src/containers/settings/Sections.js